module.exports = __webpack_public_path__ + "img/17.27c1af1a.jpg";